export default {
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.system': '系统设置',
  'menu.system-role-manage': '角色管理',
  'menu.system.system-role-manage': '角色管理',
  'menu.system-user-management': '用户管理',
  'menu.system.system-user-management': '用户管理',

  memberManage: '会员管理',
  tournamentManagement: '锦标赛管理',
  bonusManagement: '奖金管理',
  invitationManagement: '邀请管理',
  reportManage: '报表管理',
  financeManage: '财务管理',
  platformManage: '站点管理',
  systemSet: '系统设置',

  // ========== 路由 name 兜底文案（后端 menuName 缺失时使用）==========
  login: '登录',
  // 会员管理
  'member-manage': '会员管理',
  'member-user-management': '会员列表',
  'member-hierarchical-management': '层级管理',
  'member-signin-query': '登录查询',
  'member-sms-record': '验证码',
  'member-kyc': 'KYC',
  // 锦标赛管理
  'tournament-manage': '锦标赛管理',
  'tournament-manage-hall': '大厅',
  'tournament-manage-ticket': '门票管理',
  'tournament-manage-ticket-record': '门票明细',
  'tournament-manage-room': '房间查询',
  // 奖金管理
  'bonus-manage': '奖金管理',
  'bonus-manage-inquiry': '奖金查询',
  'bonus-manage-template': '奖金文案',
  // 平台管理
  'platform-manage': '平台管理',
  'platform-manage-operLog': '操作日志',
  'banner-manage': '轮播图',
  'web-push-notifications': 'WEB推送',
  'site-message-manage': '站点消息',
  'registration-config': '注册配置',
  'sms-config': '短信设置',
  'suspended-ball': '悬浮球',
  'platform-manage-contactConfig': '社媒与客服',
  'channel-promotion': '推广渠道',
  'burial-point-setting': '埋点设置',
  'burial-point-record': '埋点记录',
  'promo-channel-manage': '渠道管理',
  'promo-domain-manage': '域名管理',
  // 系统设置
  system: '系统设置',
  'system-user-management': '用户管理',
  'system-role-manage': '角色管理',
  'system-menu-config': '菜单管理',
  'system-ip-whitelist': 'IP白名单',
  // 财务管理
  'finance-manage': '财务管理',
  'finan-outbound-review': '出款审核',
  'finan-manual-funding': '人工出入款',
  'finan-payout-channel': '出款渠道配置',
  'finan-manual-instructions': '出款说明',
  'finan-withdraw-limit': '出款限制',
  // 邀请管理
  'invitation-manage': '邀请管理',
  'invitation-manage-set': '邀请设置',
  'invitation-manage-copywriting': '邀请文案设置',
  'invitation-manage-tutorial': '邀请教程',
  // 报表管理
  'report-manage': '报表管理',
  'report-manage-moneyDetails': '资金明细',
  'report-manage-operationsReport': '运营报表',
  'report-manage-retainedReport': '保留报表',
  'report-manage-onlineUsers': '在线人数',
  // 活动管理
  'activity-benefits': '活动管理',
  'activity-benefits-settings': '活动设置',
  'activity-benefits-review': '活动审核',

  'countries.china': '中国',
  'countries.philippines': '菲律宾',
  'countries.usa_canada': '美国/加拿大',
  'countries.uk': '英国',
  'countries.japan': '日本',
  'countries.south_korea': '韩国',
  'countries.singapore': '新加坡',
  'countries.malaysia': '马来西亚',
  'countries.thailand': '泰国',
  'countries.vietnam': '越南',
  'countries.indonesia': '印度尼西亚',
  'countries.india': '印度',
  'countries.hong_kong': '香港',
  'countries.macau': '澳门',
  'countries.taiwan': '台湾',
};
